import { createFileRoute } from "@tanstack/react-router";

import { listContent } from "@/lib/cms.functions";
import { alternateLinks, normalizeLocale } from "@/lib/i18n";
import { ContentGrid, PageHero } from "@/components/site/ContentViews";
import { Section } from "@/components/site/Section";
import { ClosingCta } from "@/components/site/Cta";

export const Route = createFileRoute("/{-$locale}/cases/")({
  staticData: { sitemap: false },
  loader: async ({ params }) => {
    const locale = normalizeLocale((params as { locale?: string }).locale);
    const items = await listContent({ data: { kind: "case", locale } });
    return { locale, items };
  },
  head: () => ({
    meta: [
      { title: "Case Studies | factory.online" },
      { name: "description", content: "See how manufacturers cut lead times, stabilise planning and control cost with factory.online." },
      { property: "og:title", content: "Customer case studies" },
      { property: "og:description", content: "See how manufacturers cut lead times, stabilise planning and control cost with factory.online." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: alternateLinks("/cases"),
  }),
  component: CasesIndex,
});

function CasesIndex() {
  const { items, locale } = Route.useLoaderData();
  return (
    <>
      <PageHero eyebrow="Case Studies" title="Manufacturers who took back control" lead="Real results from factories running planning, scheduling and inventory on factory.online." />
      <Section>
        <ContentGrid
          items={items}
          base="/cases"
          locale={locale}
          emptyLabel="Nothing published here yet."
        />
      </Section>
      <ClosingCta />
    </>
  );
}
